import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

declare const Userlane: any;

@Injectable({
  providedIn: 'root',
})
export class UserlaneService {
  initialize() {
    if (!environment.production) {
      Userlane('init', environment.userlaneId);
    }
  }

  identify(userSettings: any) {
    if (!environment.production) {
      Userlane('identify', userSettings.user.id, {
        cc: userSettings.country.alpha2Code,
        geo: userSettings.user.region.regionCode,
        region: userSettings.user?.region?.name,
        partnerLevel: [
          userSettings.user.lenovoUserProfile?.dcgBpLevel,
          userSettings.user.lenovoUserProfile?.pcsdBpLevel,
        ]
          .filter((v) => v != null)
          .join(','),
        partnerTier: [
          userSettings.user.lenovoUserProfile?.dcgPartnerType,
          userSettings.user.lenovoUserProfile?.pcsdPartnerType,
        ]
          .filter((v) => v != null)
          .join(','),
        partnerRole: userSettings.user.lenovoUserProfile?.role,
        partnerType: userSettings.user.companies[0].companyType.name,
      });
    }
  }

  openUserlane() {
    Userlane('openAssistant');
  }
}
